<template lang="html">

  <section class="politicas">

   <section class="middle-intro row-start">

    <div class="container">
      <h1 class="title -intro">Política de cookies</h1>
    </div>

  </section>

  <div class="container">

    <p>La página web de Innopulse  www.innopulse.es utiliza “cookies” con la finalidad de poder recabar información acerca del uso que se hace de ella.</p>

    <p>Esta Política de Cookies busca informarte claramente sobre las cookies que utilizamos en nuestra página, pero si necesitas más información o aclaración, o tienes cualquier sugerencia, escríbenos un email a lopd@innopulse.es</p>

    <p>Utilizamos cookies para facilitar tu navegación en la página, distinguirte de otros usuarios, solucionar problemas y mejorar tu experiencia de uso. También podemos utilizar cookies para recabar información sobre tus referencias y personalizar nuestra web en base a ellas, previo tu consentimiento.</p>

    <h2 class="title">COOKIES</h2>

    <p>Las cookies son archivos que se descargan en tu dispositivo para almacenar información sobre las preferencias y usos que haces en nuestra página.</p>
    <p>La información que se guarda en estos archivos puede actualizarse y ser recuperada, e incluye datos como el momento en que visitas nuestra web, cuántas páginas visitas y en qué orden… así como el tiempo que empleas en él y los sitios que visitas antes y después.</p>

    <h2 class="title">TIPO DE COOKIES QUE SE USAN EN NUESTRA WEB</h2>
    <p>La página web de Innopulse utiliza cookies de terceros.</p>

    <h3 class="title">COOKIES DE TERCEROS</h3>
    <p>Utilizamos el sistema de medición de Google, Analytics, para medir las interacciones de los usuarios con los contenidos en nuestra página, saber el número total de usuarios que tenemos y las partes más populares de la web.</p>

    <h4 class="title -intro">__UTMA</h4>
    <p>Duración - Dos años a partir de la configuración o actualización.</p>

    <p>Descripción - Se usa para distinguir usuarios y sesiones. La cookie se crea cuando se ejecuta la biblioteca JavaScript y no hay ninguna cookie __utma. La cookie se actualiza cada vez que se envían datos a Google Analytics.</p>

    <h4 class="title -intro">__UTMT</h4>
    <p>Duración - 10 minutos</p>

    <p>Descripción - Se usa para limitar el porcentaje de solicitudes.</p>

    <h4 class="title -intro">__UTMB</h4>
    <p>Duración - 30 minutos a partir de la configuración o actualización</p>

    <p>Descripción - Se usa para determinar nuevas sesiones o visitas. La cookie se crea cuando se ejecuta la biblioteca JavaScript y no hay ninguna cookie __utmb. La cookie se actualiza cada vez que se envían datos a Google Analytics.</p>

    <h4 class="title -intro">__UTMC</h4>
    <p>Duración - Fin de la sesión del navegador</p>

    <p>Descripción - No se usa en ga.js. Se configura para interactuar con urchin.js. Anteriormente, esta cookie actuaba junto con la cookie __utmb para determinar si el usuario estaba en una nueva sesión o visita.</p>

    <h4 class="title -intro">__UTMZ</h4>
    <p>Duración - Seis meses a partir de la configuración o actualización</p>

    <p>Descripción - Almacena la fuente de tráfico o la campaña que explica cómo ha llegado el usuario al sitio. La cookie se crea cuando se ejecuta la biblioteca JavaScript y se actualiza cada vez que se envían datos a Google Analytics.</p>

    <h4 class="title -intro">__UTMV</h4>
    <p>Duración - Dos años a partir de la configuración o actualización</p>

    <p>Descripción - Se usa para almacenar datos de variables personalizadas de visitante. Esta cookie se crea cuando un programador usa el método _setCustomVar con una variable personalizada de visitante. También se usaba para el método _setVar retirado. La cookie se actualiza cada vez que se envían datos a Google Analytics.</p>

    <p>Además de las de Google Analytics, pueden establecerse cookies de terceros (por ejemplo, cuando haces clic sobre los iconos de redes sociales, Facebook, Twitter…; o ves vídeos alojados en otro sitio web, Youtube o Vimeo, principalmente). Estas cookies son establecidas por un dominio diferente y no podemos acceder a los datos almacenados en las mismas.</p>

    <p>Si quieres consultar todos los detalles sobre el uso de las cookies de Google Analytics en los sitios web, puedes acceder pinchando aquí.</p>

    <p>Además de las de Google Analytics, pueden establecerse cookies de terceros (por ejemplo, cuando haces clic sobre los iconos de redes sociales, Facebook, Twitter…; o ves vídeos alojados en otro sitio web, Youtube o Vimeo, principalmente). Estas cookies son establecidas por un dominio diferente y no podemos acceder a los datos almacenados en las mismas.</p>

    <p>Si quieres consultar todos los detalles sobre el uso de las cookies de Google Analytics en los sitios web, puedes acceder pinchando aquí.</p>

    <h2 class="title">CONSENTIMIENTO</h2>
    <p>Si navegas por nuestra página web, estás consintiendo el uso de las cookies.</p>

    <h2 class="title">DESHABILITAR Y BLOQUEAR COOKIES, Y RETIRAR TU CONSENTIMIENTO</h2>
    <p>Puedes evitar que se almacenen estas cookies en tu dispositivo y seguir navegando en nuestra página (aunque algunos de los contenidos o servicios podrían ser limitados) navegando de incógnito o deshabilitando las cookies en tu navegador.</p>

    <p>Si estabas de acuerdo con la instalación de cookies pero has cambiado de idea, puedes retirar tu consentimiento simplemente eliminando las cookies que se hubieran almacenado en tu dispositivo.</p>

    <p>Para obtener información sobre cómo navegar de incógnito, deshabilitar y/o eliminar las cookies, tienes que leer la documentación de uso del navegador que utilizas sobre configuración y ajustes de cookies.</p>

    <p>Te dejamos enlaces a esta documentación de los navegadores más populares:</p>

    <p><a href="http://www.allaboutcookies.org/es/administrar-las-cookies/internet-explorer9-plus.html" target="_blank">Internet Explorer 9 </a></p>
    <p><a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank">Internet Explorer 11 </a></p>
    <p><a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank">Microsft Edge</a></p>
    <p><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank">Firefox</a></p>
    <p><a href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=es" target="_blank">Chrome</a></p>
    <p><a href="https://support.apple.com/kb/ph21411?locale=es_ES" target="_blank">Safari</a></p>

    <h2 class="title">CAMBIOS EN LA POLÍTICA DE COOKIES</h2>
    <p>Podríamos actualizar esta Política de Cookies en cualquier momento, por lo que te recomendamos que compruebes los términos cada vez que navegues en la página web de Innopulse.</p>




  </div>

</section>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-cookies',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped >
.politicas .container .-intro{
  font-size: 18px;
  margin-bottom: 10px;
}

.politicas .container .-intro::before{
  height: 12px;
  width: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/views/politica-de-cookies.vue